// biome-ignore lint/style/noRestrictedImports: migrated from develop
import { Tooltip as ChakraTooltip, type TooltipProps } from '@chakra-ui/react';
import classNames from 'classnames';

import styles from './RevelioTooltip.module.css';

interface RevelioTooltipProps extends TooltipProps {
  label: string;
}

export const RevelioTooltip = ({
  children,
  className,
  ...props
}: RevelioTooltipProps) => {
  return (
    <ChakraTooltip
      hasArrow
      variant="label"
      maxWidth="170px"
      fontSize="xs"
      lineHeight="15px"
      openDelay={400}
      p={2}
      className={classNames(styles.tooltip, className)}
      {...props}
    >
      {children}
    </ChakraTooltip>
  );
};
